import { SplashScreen } from "./SectionSplashScreen";

export default SplashScreen;
